const orders = state => state.orders;
const userdata = state => state.userdata;
export default {
    orders,
    userdata
};